<template>
	<section v-if="hasAnyChips" class="Selection">
		<div class="Header">
			<span class="Label">Selected filters</span>
			<button
				type="button"
				class="Clear"
				aria-label="Clear All"
				@click="cleanFilters"
			>
				Clear all
			</button>

		</div>
		<TagsElement
			:chips="chips"
			@elementRemovalRequest="removeFilter"
		/>
	</section>
</template>

<script setup lang="ts">
import TagsElement from '@components/TagsElement/TagsElement.vue';
import type { IChip } from '@app/interfaces/dtos/IChip';
import { useSearchStore } from '@stores/useSearchStore';
import { FilterType } from '@domain/enums/FilterType';
import { computed, PropType } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const searchStore = useSearchStore();

const props = defineProps({
	chips: {
		type: Array as PropType<IChip[]>,
		required: true,
	},
});

const hasAnyChips = computed(() => {
	return props.chips.length > 0;
});

const cleanFilters = (): void => {
	searchStore.cleanFilters(router);
};

const removeFilter = (index: number): void => {
	const chip = props.chips[index];
	if (!chip) return;

	searchStore.removeFilterValueByType(chip.id as FilterType, chip.value, router);
};
</script>

<style scoped lang="scss">
	.Selection {
		background: $White;

		@include PaddingAreas(1.5, 1);

		@include Breakpoint(Large, ExtraLarge) {
			border-bottom: 1px solid $Grey-300;
		}

		.Header {
			display: flex;
			align-items: center;
			justify-content: space-between;

			@include MarginAreas(0, 0, 1, 0);

			.Label {
				display: block;
				color: $Grey-900;
				user-select: none;

				@include TextStyle(HeadingExtraSmall);
			}

			.Clear {
				background: none;
				border: none;
				color: $Blue-700;
				cursor: pointer;

				@include TextStyle(BodySmallRegular);
				@include PaddingAreas(0);
			}

		}
	}
</style>
